import { cloneElement, FunctionComponent, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import * as Styled from "./scene-element-container.style";
import { useUiData } from "src/ui/data";

export const SceneElementContainer: FunctionComponent = () => {
	const {
		sceneElements,
		visualization: { dragOperationActive },
	} = useUiData();

	const [placingNewProduct, setNewProduct] = useState<boolean>(false);

	const isDragging = !!dragOperationActive;
	const hasElements = sceneElements.length > 0;

	if (isDragging && !hasElements && !placingNewProduct) {
		setNewProduct(true);
	} else if (!isDragging && placingNewProduct) {
		setNewProduct(false);
	}

	if (!sceneElements.length) {
		return null;
	}

	/*
		NOTE (React 18): these CSSTransitions have no `nodeRef`, so
		react-transition-group falls back to ReactDOM.findDOMNode and React logs
		a deprecation warning on the first mount. React 17 only warned under
		StrictMode; 18.3 warns unconditionally.

		Not fixed here because nothing mounts this today — UiRenderer only calls
		addSceneElement for a selected object carrying `ui`, and
		scene-definitions.ts defines neither. Fixing it means threading a stable
		per-item RefObject into SceneElementChild alongside the existing
		`info.onRef` callback, and CSSTransition has to stay a direct child of
		TransitionGroup for that to work. Do it when scene elements are turned on.
	*/
	return (
		<Styled.SceneElementContainer>
			<TransitionGroup>
				{sceneElements.map((info, index) => {
					return (
						<CSSTransition
							key={info.element.key}
							timeout={300}
							classNames="item"
						>
							<Styled.SceneElementChild
								key={index}
								ref={info.onRef}
								data-hidden={!placingNewProduct && isDragging}
							>
								{!placingNewProduct && cloneElement(info.element)}
							</Styled.SceneElementChild>
						</CSSTransition>
					);
				})}
			</TransitionGroup>
		</Styled.SceneElementContainer>
	);
};
